// src/ui/components/intro-overlay.js
//
// <intro-overlay>
// ----------------
// Displays the premium Soft Midnight Glass intro animation.
// Behavior:
//   - Call show() to fade in and start animation
//   - Automatically fades out after animation completes
//   - Emits "intro-finished" when done
//
// Pure UI component.

import { LitElement, html } from "lit";
import { introStyles } from "ui/styles/intro.css.js";
import { glassStyles } from "ui/styles/glass.css.js";

export class IntroOverlay extends LitElement {
  static styles = [glassStyles, introStyles];

  static properties = {
    visible: { type: Boolean },
  };

  constructor() {
    super();
    this.visible = false;
    this._timer = null;
  }

  // ------------------------------------------------------------
  // Public API
  // ------------------------------------------------------------
  show() {
    this.visible = true;

    // Duration matches the SVG animation (2.4s) + fade time
    clearTimeout(this._timer);
    this._timer = setTimeout(() => {
      this.visible = false;
      this._emitFinished();
    }, 1000);
  }

  // ------------------------------------------------------------
  // Rendering
  // ------------------------------------------------------------
  render() {
    return html`
      <div class="intro ${this.visible ? "visible" : ""}">
        <div class="anim-container">${this._svg()}</div>
      </div>
    `;
  }

  // ------------------------------------------------------------
  // SVG animation
  // ------------------------------------------------------------
  _svg() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2400 1200">
        <!-- Main large frame -->
        <rect
          x="450"
          y="200"
          width="1500"
          height="800"
          rx="40"
          ry="40"
          fill="none"
          stroke="white"
          stroke-width="14"
        />

        <!-- Offset frame behind -->
        <rect
          x="550"
          y="120"
          width="1500"
          height="800"
          rx="40"
          ry="40"
          fill="none"
          stroke="white"
          stroke-width="8"
          opacity="0.35"
        />

        <!-- Offset frame in front -->
        <rect
          x="350"
          y="280"
          width="1500"
          height="800"
          rx="40"
          ry="40"
          fill="none"
          stroke="white"
          stroke-width="8"
          opacity="0.35"
        />
      </svg>
    `;
  }

  // ------------------------------------------------------------
  // Event helper
  // ------------------------------------------------------------
  _emitFinished() {
    this.dispatchEvent(
      new CustomEvent("intro-finished", {
        bubbles: true,
        composed: true,
      }),
    );
  }
}

customElements.define("intro-overlay", IntroOverlay);
